import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './styles/design-tokens.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './lib/mixpanel';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

window.Kakao.init('aead8d414d52393b833c4e3ce3dcd60f');
window.Kakao.isInitialized();
console.log("------------------");
console.log(window.Kakao.isInitialized());
console.log("------------------");

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
